import { SessionStatus } from '../../../common/enums/SessionStatus';
import type { StatusBadgeVariant } from '../../Shared/StatusBadge/StatusBadge';

/**
 * Returns the StatusBadge variant for a session status
 */
export const getSessionStatusVariant = (
  status: SessionStatus
): StatusBadgeVariant => {
  switch (status) {
    case SessionStatus.ACTIVE:
      return 'success';
    case SessionStatus.INACTIVE:
      return 'error';
    default:
      return 'neutral';
  }
};
